import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { Form, FormGroup, Label, Button, Col, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { isRequired } from '../../../../utils/validators';
import Select from '../../../common/forms/select/Select';
import { getPublicCities } from '../../../../actions';

const ItinerarySearchForm = ({ handleSubmit, submitting, loadingCity, cityList, dispatchGetPublicCities }) => {
  useEffect(() => {
    dispatchGetPublicCities();
  }, []);
  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              Destino <span className="text-danger">*</span>
            </Label>
            <Field
              name="destination"
              component={Select}
              options={cityList}
              isLoading={loadingCity}
              validate={[isRequired]}
              autoFocus
            />
          </FormGroup>
        </Col>
      </Row>
      <div className="mt-0">
        <Button type="submit" disabled={submitting} color="primary">
          <i className="fa fa-search" /> Buscar
        </Button>
      </div>
    </Form>
  )
}

ItinerarySearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  cityList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  loadingCity: PropTypes.bool,
  dispatchGetPublicCities: PropTypes.func.isRequired,
}

ItinerarySearchForm.defaultProps = {
  loadingCity: false,
}

const mapStateToProps = ({ SalesUnit, BookingUnit }) => ({
  gettingActiveSalesSession: SalesUnit.SalesSession.getIn([
    'active',
    'loading',
  ]),
  activeSalesSession: SalesUnit.SalesSession.getIn([
    'active',
    'content',
  ]),
  cityList: BookingUnit.PublicCities.get('all')
    .get('content')
    .get('content')
    .map((city) => ({
      value: city.id,
      label: city.name,
    })),
  loadingCity: BookingUnit.PublicCities.get('all').get('activity')
})

const mapDispatchToProps = {
  dispatchGetPublicCities: getPublicCities
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'itinerarySearchForm',
  })(ItinerarySearchForm),
);
